
import { Vue, prop } from "vue-class-component";

export interface PickupCorporateAddressView {
  name?: string;
  picName?: string;
  phoneNumber?: string;
  address?: string;
  latLon?: string;
}

class Props {
  isPcaEmpty = prop<boolean>({
    default: true
  });
  corporateAddress = prop<PickupCorporateAddressView | null>({
    default: null
  });
  fallbackAddress = prop<string>({
    default: ""
  });
  fallbackGeoloc = prop<string>({
    default: ""
  });
  courierNote = prop<string>({
    default: ""
  });
  loading = prop<boolean>({
    default: false
  });
}

export default class PickupDetailRequestInfo extends Vue.with(Props) {
  get pcaName() {
    return (
      this.corporateAddress?.name ||
      this.$t("pickupV2.detail.requestInfo.warehousePrefix")
    );
  }
  get getCourierNote() {
    return (
      this.courierNote?.trim() ||
      this.$t("pickupV2.detail.requestInfo.courierNoteEmpty")
    );
  }
  get pcaAddress() {
    return (
      this.corporateAddress?.address?.trim() || this.fallbackAddress.trim()
    );
  }
  get pcaLatlon() {
    return this.corporateAddress?.latLon?.trim() || this.fallbackGeoloc.trim();
  }
  get pcaContact() {
    return [
      this.corporateAddress?.picName?.trim(),
      this.corporateAddress?.phoneNumber?.trim()
    ]
      .filter(Boolean)
      .join("- ");
  }
  get hasAddressData() {
    return (
      !this.isPcaEmpty ||
      Boolean(this.fallbackAddress?.trim()) ||
      Boolean(this.fallbackGeoloc?.trim())
    );
  }
}
